import cn from 'classnames'
import React from 'react'

//
import { IconNew, ButtonNew, SimpleContentBlock } from '..'
import { LocationContext, SiteDataContext } from '../../components'
import { getUrl } from '../../utils/urls'
import SectionHeader, { ALIGN, HEADING_TYPE } from '../SectionHeader'
import { NavLink } from '../helpers'
import { withAnchor } from '../hooks'
import { useNavigationData } from '@/src/context/NavigationContext'

const IntegrationDetail = ({
  preface = '',
  title = '',
  contentList,
  descriptionTokens = {},
  items = [],
  children,
  anchor,
  primaryAction
}) => {
  const { navigationItems } = useNavigationData()
  const { isTextRtl } = React.useContext(SiteDataContext)
  const location = React.useContext(LocationContext)
  const { slugPrefix } = location

  const doesContentListExists = contentList && contentList.length > 0

  const itemsToShow =
    contentList.length > 0
      ? items.map(({ id, title, url, logo }) => (
          <NavLink
            to={url}
            key={id}
            className="l-grid l-grid--align:center l-grid__col:6/12 l-grid__col:3/12@at:viewport-4"
          >
            <img
              loading="lazy"
              key={id}
              src={logo}
              title={title}
              alt={title}
              width="72"
              height="72"
            />
          </NavLink>
        ))
      : items.map(({ id, title, url, logo }) => (
          <NavLink to={url} key={id} className="c-integration-listing__logo-container">
            <img
              loading="lazy"
              key={id}
              src={logo}
              title={title}
              alt={title}
              width="72"
              height="72"
            />
          </NavLink>
        ))

  return (
    <section
      className={cn('l-section c-integration-listing', {
        'c-integration-listing__with-content-list l-section--no-padding-top': doesContentListExists,
        'l-section--force-padding': !doesContentListExists
      })}
      dir={isTextRtl ? 'rtl' : 'ltr'}
    >
      <div className="l-container:12/12 l-container--default-spacing">
        <div className="l-grid l-grid--default-spacing l-grid--spacing:20">
          <div
            className={cn(
              doesContentListExists
                ? 'l-grid__col:12/12 l-grid__col:6/12@at:viewport-9'
                : 'l-grid__col:12/12@at:viewport-9'
            )}
          >
            <div className="l-section__header l-container:8/12">
              <SectionHeader
                anchor={anchor}
                title={title}
                eyebrow={!contentList.length > 0 ? preface : null}
                text={contentList.length > 0 ? preface : null}
                textTokens={descriptionTokens}
                headingType={HEADING_TYPE.h2}
                align={doesContentListExists ? ALIGN.left : ALIGN.center}
              />
            </div>

            <div className="l-section__content c-integration-listing__content">
              <hr />
              <div className="c-integration-listing__logos">
                <div className="l-grid l-grid--default-spacing">
                  {items.length > 0 && itemsToShow}
                </div>
              </div>

              <hr />
            </div>
            {primaryAction ? (
              <div
                className={cn('c-integration-listing__action-container', {
                  'u-text-align:center': !doesContentListExists
                })}
              >
                <ButtonNew
                  variant="green"
                  url={getUrl({
                    navItem: primaryAction,
                    slugPrefix: slugPrefix,
                    navigationItems: navigationItems
                  })}
                >
                  {primaryAction.title} <IconNew name={'tabler-arrow-narrow-right'} />{' '}
                </ButtonNew>
                {primaryAction.subtext ? <p>{primaryAction.subtext}</p> : null}
              </div>
            ) : null}

            {children ? <div className="l-section__footer">{children}</div> : null}
          </div>
          {doesContentListExists ? (
            <div className="l-grid__col:6/12@at:viewport-9 c-integration-listing__list">
              {contentList.map(({ sys, title, icon, description }, i) => (
                <SimpleContentBlock
                  key={sys?.id || `content-list-${i}`}
                  classes="c-integration-listing__list-item"
                  icon={icon}
                  title={title}
                  bulletListColor={'white'}
                  description={description}
                />
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  )
}

export default withAnchor(IntegrationDetail)
